import {
  addEvent,
  addViewEvent,
  initTelemetry,
  telemetryLogin,
  telemetryLogout,
} from '@creditornot/browser-telemetry';

import { CustomDestination, EventNameValueType, LogTypeValueType } from './avo/Avo';

type EventProperties = {
  log_type: LogTypeValueType;
  view?: string;
  event_name?: EventNameValueType;
  duration_ms?: number;
  attributes?: Record<string, any>;
};

type ViewEventProperties = {
  duration_ms: number;
  attributes?: Record<string, any>;
};

export const Gatekeeper: CustomDestination = {
  make: (): void => {
    void initTelemetry({
      disabled: import.meta.env.DEV,
      endpoint: import.meta.env.VITE_GATEKEEPER_URI,
      appVersion: __SHORT_VERSION_HASH__,
      logging: import.meta.env.VITE_TELEMETRY_LOGGING_ENABLED === 'true',
      requestHeaders: {
        'x-api-key': import.meta.env.VITE_TELEMETRY_API_KEY,
      },
    });
  },
  logEvent: (_: string, eventProperties: Record<string, any>): void => {
    const { log_type, view, event_name, duration_ms, ...otherEventProperties } =
      eventProperties as EventProperties;
    addEvent({
      log_type,
      view,
      event_name,
      duration_ms,
      attributes: otherEventProperties,
    });
  },

  // @args (userId: string, userProperties: object)
  setUserProperties: (): void => {
    // Set user properties
  },
  identify: (userId: string): void => {
    telemetryLogin(userId);
  },
  unidentify: (): void => {
    telemetryLogout();
  },
  logPage: (pageName: string, viewEventProperties: Record<string, any>): void => {
    const { duration_ms, ...otherEventProperties } = viewEventProperties as ViewEventProperties;
    addViewEvent(pageName, duration_ms || 0, otherEventProperties);
  },
};
